/**
 * GraphQL Queries
 * Export all queries from this file
 * 
 * Example:
 * export { GET_USER } from './user.queries';
 * export { GET_PRODUCTS } from './product.queries';
 */

import { gql } from "@apollo/client";

// Placeholder - Add your queries here
// Example:
// export const GET_USER = gql`
//   query GetUser($id: ID!) {
//     user(id: $id) {
//       id
//       name
//       email
//     }
//   }
// `;

/**
 * Services query (matches backend schema)
 *
 * Variables:
 * - page: Int
 * - limit: Int
 */
// Featured services only (featured is 1 or 0)
export const GET_SERVICES = gql`
  query Services($page: Int, $limit: Int, $featured: Boolean) {
    services(
      pagination: { page: $page, limit: $limit }
      filters: { featured: $featured }
    ) {
      data {
        id
        service_name
        service_price
        service_duration
        service_description
        service_type
        target_audience
        status
        slug
        treatment_type
        resource
        online_booking
        featured
        sortOrder
        image {
          url
        }
        createdAt
        updatedAt
      }
      meta {
        total
        page
        limit
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;
// Services with category query
export const GET_SERVICES_WITH_CATEGORY = gql`
  query ServicesWithCategory(
    $pagination: PaginationInput
    $filters: ServiceFilterInput
    $includeDeleted: Boolean
  ) {
    services(
      pagination: $pagination
      filters: $filters
      includeDeleted: $includeDeleted
    ) {
      data {
        id
        service_name
        service_price
        service_duration
        service_description
        service_type
        target_audience
        status
        slug
        treatment_type
        resource
        online_booking
        featured
        requiresUpfrontPayment
        service_categoryId
        imageId
        sortOrder
        service_category {
          id
          name
          slug
          sortOrder
        }
        parentId
        image {
          url
        }
        createdAt
        updatedAt
        deletedAt
      }
      meta {
        total
        page
        limit
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;

export const GET_SERVICE_CATEGORIES = gql`
  query GetServiceCategories(
  $pagination: PaginationInput
  $filters: ServiceCategoryFilterInput
) {
  serviceCategories(pagination: $pagination, filters: $filters) {
    data {
      id
      name
      icon
      slug
      status
      sortOrder
    }
    meta {
      total
      page
      limit
      totalPages
      hasNext
      hasPrevious
    }
  }
}
`;
export const GET_SERVICE_CATEGORIES_FULL = gql`
  query GetServiceCategoriesFull(
  $pagination: PaginationInput
  $filters: ServiceCategoryFilterInput
) {
  serviceCategories(pagination: $pagination, filters: $filters) {
    data {
      id
      name
      description
      slug
      icon
      status
      sortOrder
      createdAt
      updatedAt
    }
    meta {
      total
      page
      limit
      totalPages
      hasNext
      hasPrevious
    }
  }
}
`;

// Appointments

export { GET_APPOINTMENTS, GET_APPOINTMENT } from "./appointments.queries"
export { GET_ME, GET_ME_WALLET } from "./auth.queries"
export { GET_GENERAL_SETTINGS_POLICIES } from "./settings.queries"